import { Button } from "@novaescola/eva-react-v2/lib/Button";
import { Typography } from "@novaescola/eva-react-v2/lib/Typography";
import { StaticImage } from "gatsby-plugin-image";
import * as React from "react";

const NeedHelpDiscrepancy = () => {

  const onClick = () => {
    window.location.href = '/fichas-de-recomposicao-de-aprendizagem';
  }

  return (
    <div className="need-healp-discrepancy d-flex ai-center eva-mb-08">
      <div className="image">
      <StaticImage
          src="https://s3.amazonaws.com/files.especial.novaescola.org.br/images/need-healp-discrepancy.png"
          alt=""
          width={135}
          height={110}
        />
      </div>
      <div>
        <Typography variant="title" size={6} asChild className="eva-mb-03">
          <p>Ainda precisa de ajuda na defasagem dos alunos?</p>
        </Typography>
        <Typography variant="body" size={2} asChild className="eva-mb-05">
          <p>Confira outras fichas de recomposição com as habilidades prioritárias de Língua Portuguesa e Matemática</p>
        </Typography>
        <Button color="white" style={{borderColor: '#000'}} size="small" onClick={onClick}>
          Ver todas as fichas
        </Button>
      </div>
    </div>
  );
};


export default NeedHelpDiscrepancy;
